import { render, staticRenderFns } from "./base-form-builder.vue?vue&type=template&id=74c2a376&"
import script from "./base-form-builder.vue?vue&type=script&lang=ts&"
export * from "./base-form-builder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports